var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
/**
 * Recursively merges two objects into a new object. Similar to https://lodash.com/docs/4.17.15#merge
 * @param {Object} obj1 - The first object to merge.
 * @param {Object} obj2 - The second object to merge.
 * @returns {Object} A new object with properties merged from both input objects.
 */
export function recursiveMergeObjects(obj1, obj2) {
    var merged = __assign({}, obj1);
    for (var key in obj2) {
        if (obj2.hasOwnProperty(key)) {
            if (typeof obj2[key] === 'object' && !Array.isArray(obj2[key])) {
                merged[key] = recursiveMergeObjects(merged[key] || {}, obj2[key]);
            }
            else {
                merged[key] = obj2[key];
            }
        }
    }
    return merged;
}
